export function resolveApiBaseUrl() {
  const explicitUrl = process.env.REACT_APP_BACKEND_URL?.trim();
  if (explicitUrl) {
    return explicitUrl.replace(/\/$/, '');
  }

  if (typeof window === 'undefined') return '';

  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:8000`;
}

export const API_BASE_URL = resolveApiBaseUrl();
